export const MARKET_STATS_BAR_CELL_CLASSNAME =
	'flex flex-col justify-center px-sm xl:px-xl';

export const MARKET_STATS_BAR_CELL_LABEL_CLASSNAME =
	'md:mb-1 typo-b5 md:typo-b4 text-text-secondary';

export const MARKET_STATS_BAR_CELL_VALUE_CLASSNAME =
	'typo-t3 text-text-default';

export const MARKET_STATS_BAR_CELL_VALUE_SKELETON_CLASSNAME =
	'w-full xs:my-[0.5px] xs:h-md sm:my-2xs sm:h-[14px]';
